import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { ToastrService } from '../../../../shared/services/utilities/toastr.service';
import { Subscription } from 'rxjs';
import { FormCheckboxService } from '../../../../shared/services/utilities/form-checkbox.service';
import { OnDestroyComponent } from '../../../../shared/components/on-destroy/on-destroy.component';
import { AutoUnsubscribe } from '../../../../utils/misc/auto-unsubscribe';
import { KAZA_CONST } from '../../../../utils/const/kaza';
import { minCheckboxSelected } from '../../../../utils/validators/min-checkbox-selected.validator';
import { ProjectType, subRProperty } from '@adeo/ngx-kozikaza-api';
import { KazaService as LegacyKazaService } from '../../../../shared/services/features/kaza/kaza.service';

@Component({
  selector: 'app-kaza-edit-types',
  templateUrl: './kaza-edit-types.component.html',
  styleUrls: ['./kaza-edit-types.component.scss']
})
@AutoUnsubscribe([])
export class KazaEditTypesComponent extends OnDestroyComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() kazaForm: UntypedFormGroup;
  @Input() types: any;
  @Output() typesFormatted: EventEmitter<any> = new EventEmitter<any>();

  projectTypes: Array<ProjectType>;
  formArray: UntypedFormArray;
  kazaTypeNoWork: string = KAZA_CONST.KAZATYPE_NO_WORK;
  private subscriptionKazaGetTypes: Subscription;
  private subscriptionKazaFormGetTypes: Subscription;

  constructor(
    private toastr: ToastrService,
    private kazaService: LegacyKazaService,
    private formCheckboxService: FormCheckboxService
  ) {
    super();
  }

  ngOnInit(): void {
    this.projectTypes = Array<ProjectType>();
    this.initForm();
    this.loadProjectTypes();
  }

  ngAfterViewInit(): void {
    this.watchControl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.types && changes.types.currentValue && this.projectTypes) {
      this.formCheckboxService.buildCheckbox(this.formArray, this.projectTypes, this.types);
    }
  }

  initForm(): void {
    this.formArray = new UntypedFormArray([], minCheckboxSelected(1));
    this.kazaForm.addControl('types', this.formArray);
  }

  watchControl(): void {
    this.subscriptionKazaFormGetTypes = this.kazaForm.get('types').valueChanges.subscribe(
      (data) => {
        this.typesFormatted.emit(this.formCheckboxService.formatData(data, this.projectTypes));
      }
    );
  }

  loadProjectTypes(): void {
    this.subscriptionKazaGetTypes = this.kazaService.getTypes().subscribe(
      data => {
        this.projectTypes = data;
        this.formCheckboxService.buildCheckbox(this.formArray, this.projectTypes, this.types);
      },
      err => {
        this.toastr.error($localize`:@@toast.error_try_again:An error has occurred. Please try again`);
      }
    );
  }

  changeProjectTypes(projectType: ProjectType|string, projectTypeCheckbox): void {
    const indexNoWork = this.projectTypes.findIndex(i => i['@id'] === this.kazaTypeNoWork);
    if (projectType['@id'] === this.kazaTypeNoWork && projectTypeCheckbox.target.checked) {
      if (projectTypeCheckbox.target.checked) {
        // Check only kazaTypeNoWork
        this.formCheckboxService.buildCheckbox(this.formArray, this.projectTypes, [projectType]);
      }
    } else {
      // If other value, set false to checkbox of kazaTypeNoWork
      this.kazaForm.controls.types[`controls`][indexNoWork].setValue(false);
    }
  }

  getProjectTypeImg(projectType: ProjectType): string {
    const img = subRProperty(projectType, ['media', 'thumbs', 'medium'], null);
    return img;
  }

}
